import { Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/form/baseInputs/Button';
import { AlertTriangleIcon } from '@/components/icons/AlertTriangleIcon';
import { Badge, BadgeVariants } from '@/components/notifications/Badge/Badge';
import { Tooltip } from '@/components/poppers/Tooltip/Tooltip';
import { useTrackUserEvent } from '@/hooks/useTrackUserEvent';
import { useCanEditHouseholdData } from '@/modules/authentication/hooks/useCanEditHouseholdData';

import { useMarkValidationQuestionNotificationsRead } from './hooks/useMarkValidationQuestionNotificationsRead';
import { getValidationQuestionsPath } from './validationQuestions.paths';

export function ValidationQuestionsBadge({
  householdId,
}: {
  householdId: string;
}) {
  const navigate = useNavigate();
  const canEdit = useCanEditHouseholdData();
  const trackUserEvent = useTrackUserEvent();
  const markNotificationsRead =
    useMarkValidationQuestionNotificationsRead(householdId);

  return (
    <Tooltip
      placement="bottom"
      title={
        <Stack spacing={1} onClick={(event) => event.stopPropagation()}>
          <Typography variant="body-xs">
            Processing is paused for this household. Complete validation
            questions to finish building the household and create deliverables.
          </Typography>
          <Button
            variant="primary"
            size="xs"
            sx={{ alignSelf: 'flex-end' }}
            disabled={!canEdit}
            onClick={() => {
              markNotificationsRead();
              navigate(getValidationQuestionsPath(householdId));
              trackUserEvent(
                'household_chat validation_questions_badge_clicked',
                {
                  householdId,
                }
              );
            }}
          >
            View validation questions
          </Button>
        </Stack>
      }
    >
      <Badge
        variant={BadgeVariants.Warning}
        aria-label="Needs attention"
        role="img"
        sx={{ width: 18, height: 18, p: 0 }}
        display={<AlertTriangleIcon size={14} aria-hidden />}
      />
    </Tooltip>
  );
}
